import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import CurrentScreen from '../containers/CurrentScreen';
import Cursor from '../containers/Cursor';
import Device from '../containers/Device';
import ExternalPrototype from '../containers/ExternalPrototype';
import LoadingScreen from '../containers/LoadingScreen';
import PreviewScreen from '../containers/PreviewScreen';
import PreviousScreen from '../containers/PreviousScreen';
import StatusBarUnderlay from '../containers/StatusBarUnderlay';
import TouchIndicator from '../containers/TouchIndicator';
import EmptyProject from './EmptyProject';
import styles from './Player.module.css';
export default function Player(_a) {
    var _b;
    var areHotspotsLoaded = _a.areHotspotsLoaded, areInitialScreensPreloaded = _a.areInitialScreensPreloaded, backgroundColor = _a.backgroundColor, externalPrototypeUrl = _a.externalPrototypeUrl, isEmpty = _a.isEmpty, isInHandoffMode = _a.isInHandoffMode, isPlaying = _a.isPlaying, transition = _a.transition;
    if (isEmpty) {
        return (React.createElement(Device, null,
            React.createElement(EmptyProject, null)));
    }
    var className = cx(styles.player, styles[transition], (_b = {},
        _b[styles.handoffMode] = isInHandoffMode,
        _b));
    var style = isInHandoffMode
        ? undefined
        : { backgroundColor: "#".concat(backgroundColor) };
    return (React.createElement(React.Fragment, null,
        React.createElement(TouchIndicator, null),
        externalPrototypeUrl && areHotspotsLoaded ? (React.createElement(ExternalPrototype, { src: externalPrototypeUrl })) : (React.createElement(Device, null,
            React.createElement("div", null,
                React.createElement("div", { className: className, style: style },
                    !isInHandoffMode && React.createElement(StatusBarUnderlay, null),
                    isPlaying && areInitialScreensPreloaded && areHotspotsLoaded ? (React.createElement("div", null,
                        React.createElement(PreviousScreen, { key: "previous" }),
                        React.createElement(CurrentScreen, { key: "current" }))) : (React.createElement(PreviewScreen, null)),
                    React.createElement(Cursor, null)),
                React.createElement(LoadingScreen, null))))));
}
Player.propTypes = {
    isPlaying: PropTypes.bool.isRequired,
    isInHandoffMode: PropTypes.bool.isRequired,
    areInitialScreensPreloaded: PropTypes.bool.isRequired,
    areHotspotsLoaded: PropTypes.bool.isRequired,
    transition: PropTypes.string,
    backgroundColor: PropTypes.string.isRequired,
    isEmpty: PropTypes.bool.isRequired,
};
